import React from "react";
import styled from "styled-components";
import Text from "src/components/Text";
import { SharedDateInput, SharedDateTimeInput } from "./DateTimePickerInputs";

export const ErrorText = styled(Text)`
    color: red;
    text-align: ${p => (p.align || p.errorTextAlign) || "left"};
    font-size: 12px;
    margin: ${p => p.errorMargin || "0 20px 5px"};
    height: ${p => (p.errorTextHeight) || "12px"};
    white-space: pre-wrap;

    &:empty {
        display: none;
    }
`;

const getDateTimeContainerStyle = (style) => {
    if (!style) return undefined;
    const { margin, marginTop, marginRight, marginBottom, marginLeft, width, maxWidth, minWidth } = style;
    return { margin, marginTop, marginRight, marginBottom, marginLeft, width, maxWidth, minWidth };
};

const getDateTimeFieldStyle = (style) => {
    if (!style) return undefined;
    const fieldStyle = { ...style };
    [
        "border",
        "margin",
        "marginTop",
        "marginRight",
        "marginBottom",
        "marginLeft",
        "width",
        "maxWidth",
        "minWidth",
    ].forEach(key => delete fieldStyle[key]);
    return fieldStyle;
};

const hasErrorBorder = (style) => {
    if (!style?.border) return false;
    return String(style.border).toLowerCase().includes("red") || String(style.border).toLowerCase().includes("#d64545");
};

export default function ValidatedDateInput({
    errors,
    placeholder,
    onChange,
    showErrors,
    errorTextAlign,
    value,
    disabled,
    minDate,
    showTime = false,
    backgroundColor,
    fontWeight,
    size,
    style,
    datePickerPlacement,
    timePickerPlacement,
    dateTimeColumns,
    onCalendarOpen,
    onCalendarClose,
    ...otherProps
}) {
    const errorsArray = errors || [];
    const isError = Boolean(showErrors || hasErrorBorder(style));

    return (
        <>
            {showTime ? (
                <SharedDateTimeInput
                    value={value}
                    onChange={onChange}
                    placeholder="Select date"
                    timePlaceholder="Select time"
                    disabled={disabled}
                    minDate={minDate}
                    isError={isError}
                    size={size}
                    fontWeight={fontWeight}
                    backgroundColor={disabled ? "#F0F0F0" : backgroundColor}
                    inputStyle={getDateTimeFieldStyle(style)}
                    style={getDateTimeContainerStyle(style)}
                    datePickerPlacement={datePickerPlacement}
                    timePickerPlacement={timePickerPlacement}
                    columns={dateTimeColumns}
                    onCalendarOpen={onCalendarOpen}
                    onCalendarClose={onCalendarClose}
                    {...otherProps}
                />
            ) : (
                <SharedDateInput
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    disabled={disabled}
                    minDate={minDate}
                    isError={isError}
                    size={size}
                    fontWeight={fontWeight}
                    backgroundColor={disabled ? "#F0F0F0" : backgroundColor}
                    inputStyle={style}
                    popperPlacement={datePickerPlacement}
                    onCalendarOpen={onCalendarOpen}
                    onCalendarClose={onCalendarClose}
                    {...otherProps}
                />
            )}
            {showErrors && <ErrorText errorTextAlign={errorTextAlign} {...otherProps}>{errorsArray}</ErrorText>}
        </>
    );
}
